import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const GroupSelector = ({ groupOptions = [], selectedGroup, handleGroupChange }) => {
    return (
        <FormControl sx={{ width: '100%' }}>
            <InputLabel id="group-label">Change Group</InputLabel>
            <Select labelId="group-label" id="group-selector" value={selectedGroup} label="Change Group" onChange={handleGroupChange} sx={{ width: '100%', minWidth: '150px' }}>
                {groupOptions.map((group) => (
                    <MenuItem key={group._id} value={group._id}>
                        {group.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default GroupSelector;
